import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'auth-config-display',
    template: require('./admin.auth-config-display.component.html')
})
export class AuthConfigDisplayComponent implements OnInit {

    @Input() config: any = null;

    constructor() { }
    ngOnInit() { }

}